import "../../../../styles/workspace_styles/CustomerAdministratorStyles/Invoices/Invoices.css";
import NavigationBar from "../../../navigation_components/NavigationBar";
import CustomerAdministratorSideBar from "../../../sidebar_components/CustomerAdministratorSideBar";
import { billingMicroserviceUrl } from "../../../../microservices/billing_microservice";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../../AppProvider";
import { InvoiceContext } from "./InvoiceProvider";
import Invoice from "./Invoice/Invoice";

const InvoicesTable = () =>{
    const {invoices,setSelectedInvoiceSummary} = useContext(InvoiceContext);
    const statusColors = {
        CREATED: "gray",
        ISSUED: "darkorange",
        PAID: "green"
    };
    return(
        <div className="customer-administrator-invoices-table-container">
            <table className="customer-administrator-invoices-table">
                <thead>
                    <tr id="customer-administrator-invoices-header-row">
                        <th>Invoice Number</th>
                        <th>Issue Date </th>
                        <th>Due Date</th>
                        <th>Customer</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {invoices.map((invoice) => (
                        <tr key={invoice?.id} onClick={() => {
                            setSelectedInvoiceSummary(invoice);
                        }}>
                            <td>a{invoice?.invoiceNumber}</td>
                            <td>{invoice?.createDate}</td>
                            <td>{invoice?.dueDate}</td>
                            <td>{invoice?.customerName}</td>
                            <td style={{color:statusColors[invoice?.status] || 'black'}}>
                                {invoice?.status? `${invoice.status.charAt(0)}${invoice.status.slice(1).toLowerCase()}`:''}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
const Invoices = () =>{
    const {user,logout} = useContext(AppContext);
    const {
        setInvoices
    } = useContext(InvoiceContext);
    const [invoicesFetchStatus,setInvoicesFetchStatus] = useState('');
    const fetchInvoices = async() =>{
        try{
            setInvoicesFetchStatus('fetching');
            const url = `${billingMicroserviceUrl}/customers/invoices`;
            const response = await fetch(url,{
                method:'Get',
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Bearer ${user?.access_token}`
                }
            });
            if(response.ok){
                setInvoices(await response.json());
                setInvoicesFetchStatus('fetched');
                return;
            }
            else if(response.status === 401) logout();
            else if(response.status === 500) throw new Error(`response status: ${response.status}`);
        }
        catch(error){
            console.error('An error occurred when retrieving invoices',error);
        }
        setInvoicesFetchStatus('error');
    };
    useEffect(() =>{
        document.title = 'Blink IOT | Invoices';
        if(invoicesFetchStatus === '') fetchInvoices();
    },[]);
    useEffect(() =>{
        if(invoicesFetchStatus === '') fetchInvoices();
    },[invoicesFetchStatus]);
    return(
        <div className="customer-administrator-invoices-page">
            <NavigationBar/>
            <div className="customer-administrator-invoices-page-layout">
                <div>
                    <CustomerAdministratorSideBar/>
                </div>
                <div className="customer-administrator-invoices-parent-container">
                    <div className="customer-administrator-invoices-container">
                        <div className="customer-administrator-invoices-header-container">
                            <h2>Invoices</h2>
                            <div className="customer-administrator-invoices-header-controls">
                                <button
                                    className="customer-administrator-refresh-invoices-button"
                                    title="Refresh"
                                    onClick={() =>{}}>
                                    <img src={`${process.env.PUBLIC_URL}/images/refresh-icon.png`} alt="Refresh"/>
                                </button>
                            </div>
                        </div>
                        {
                            <div>
                                <InvoicesTable/>
                                <Invoice/>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Invoices;